<template>
  <v-sheet elevation="0" width="100%" class="pa-3" style="margin-bottom: 1px; background-color: #CFD8DC;">
    <div>Author: <b>{{author}}</b></div>
    <div>Time: <b>{{formatTime(time)}}</b></div>
    <div><i>{{text}}</i></div>
  </v-sheet>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    author: String,
    time: String,
    text: String,
  },

  methods: {
    formatTime(time) {
      return moment(time).local().format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
